import { isString, formatDate } from '@tencent/slug-function';
// formatNumber, newSmartData,
const filters = {
  totalPlay(value) {
    if (isString(value) === true) {
      if (value.indexOf('万') > 0) {
        return value;
      }
    }
    return value > 10000 ? `${(value / 10000).toFixed(1)}万` : value;
  },

  // url转成https
  toHttps(url) {
    return url && url.replace(/^http:/, 'https:').replace(/／/g, '\/');
  },
  formatTime(value, format = 'MM月dd日') {
    return formatDate(value, format, {});
  },
  // encodeURI(val) {
  //   return encodeURIComponent(val);
  // },
  // decodeURI(val) {
  //   return decodeURIComponent(val);
  // },
  /* 千分位*/
  // splitThousands(val) {
  //   return `${val}`.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
  // },

  // 统一处理播放量
  // betterV4Watch({ iTotalPlay = 0 }) {
  //   const n = f(iTotalPlay);
  //   return formatNumber(n, 1);
  // },
  // 原本的播放量处理 Part2


  // welfareTag(txt) {
  //   return !txt || txt.indexOf('前往参与') > -1 ? '福利活动' : txt;
  // },
};

export default (Vue) => {
  Object.keys(filters).forEach((item) => {
    Vue.filter(item, filters[item]);
  });
};
